import { Star } from "lucide-react";
import { SliderQuestion as SliderQuestionType } from "./types";
import { QuestionTooltip } from "./QuestionTooltip";

interface StarRatingQuestionProps {
  question: SliderQuestionType;
  value: number;
  onChange: (questionId: string, value: number) => void;
}

export function StarRatingQuestion({
  question,
  value,
  onChange,
}: StarRatingQuestionProps) {
  const maxStars = question.maxValue || 5;
  const currentValue = value || 0;

  return (
    <div className="space-y-8 w-full max-w-3xl mx-auto py-4">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-3">{question.title}</h2>
        {question.description && <p className="text-muted-foreground">{question.description}</p>}
        {question.tooltip && <QuestionTooltip tooltip={question.tooltip} />}
      </div>

      <div className="flex items-center justify-center gap-2 py-6">
        {Array.from({ length: maxStars }, (_, i) => {
          const starValue = i + 1;
          return (
            <button
              key={starValue}
              type="button"
              onClick={() => onChange(question.id, starValue)}
              className="p-1 transition-transform hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded"
              aria-label={`${starValue} star${starValue > 1 ? 's' : ''}`}
            >
              <Star
                className={`w-10 h-10 transition-colors ${
                  starValue <= currentValue
                    ? 'fill-primary text-primary'
                    : 'fill-none text-muted-foreground/40'
                }`}
              />
            </button>
          );
        })}
      </div>

      {question.labels && (
        <div className="flex justify-between text-sm text-muted-foreground">
          <span>{question.labels.min}</span>
          <span>{question.labels.max}</span>
        </div>
      )}
    </div>
  );
}
